import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material'

import closeIcon from '../../../images/closeIcon.svg';
import logo from '../../../images/logo.png';
import smallLogo from '../../../images/smallLogo.svg';
import endOfFormation from '../../../images/endOfFormation.png';
import vignetteModule from '../../../images/vignetteModule.png';

import LanguageContext from "../../../contexts/LanguageContext"
import { useTexte } from "../../../contexts/FormeAdresseContext"
import UserContext from "../../../contexts/UserContext"
import { getCurrentUser } from "../../../utils/auth"
import { GLB_URL_THESCAN } from "../../../utils/APIS"
import { scoresCalculesParLeServeur } from "../../../utils/scoresServeur"

import SuperAdminContext from "../../../contexts/SuperAdminContext"

import EditorPopover from "../../ui/Admin/Formations/EditorPopover"

import { CenterContainer, BottomBar, BLOC_DEFILANT } from "./FormatsHelpers"

import EditableField from "./EditableField"
import EditableButton from "./EditableButton"
import SkillResultCard, { HAUTEUR_LIGNE_RESULTAT } from "../Formation/SkillResultCard"
import FenetreCertificat, { BoutonVoirCertificat } from "../Certificat/FenetreCertificat"
import { certificatDisponible } from "../Certificat/moduleTermine"
import { useCertificationDuGroupe, seuilDeCertification } from "../../../utils/accesCertification"
/* ⛔ 01/10/2026 — TROIS IMPORTS RETIRES AVEC LA MINIATURE DE MODULE.
   `ScaleThumbForm`, `FormatSwitch` et `fondDeLEcran` ne servaient qu'a rendre
   le premier ecran du module en miniature, faute d'image de module. La planche
   demande une mosaique, Hicham l'a exportee : la miniature n'a plus d'objet, et
   son outillage non plus. Les trois restent utilises ailleurs (plan de
   formation, barre laterale de l'editeur) — c'est seulement ICI qu'ils partent.
   `FormatSwitch` surtout : il importait la page Formation DEPUIS un composant de
   format, un aller-retour que ce fichier n'a plus a porter. */

const TopBar = ({ setViewPlanCours, viewPlanCours }) => {
  const navigate = useNavigate();
  const { updateUserContext } = useContext(UserContext)

  // L24 : rafraichir le contexte avant de retourner au dashboard, sinon
  // actFormation/actPlan restent perimes et il faut recharger la page.
  const goDashboard = () => {
    updateUserContext()
    navigate("/dashboard")
  }

  return (
    <Box sx={{
      background:"transparent",
      /* Lot G : meme hauteur d'en-tete que le TopBar partage (75 px releves sur
         Figma). Cet ecran redefinit sa barre localement ; sans cette ligne, le
         logo sautait de 5 px au passage depuis un format. */
      height:["60px", "75px", "75px", "75px"],
      minHeight:["60px", "75px", "75px", "75px"],
      padding:"0px 25px",
      display:"flex",
      alignItems:"center",
      justifyContent:"space-between",
      gap:["10px", "20px"],
    }}>
      {/* L20 : logo Rising Up a 60px du bord (25px de padding + 35px), 30px de haut */}
      <Box
        onClick={goDashboard}
        sx={{
          marginLeft:["0px", "35px"],
          display:"flex",
          alignItems:"center",
          cursor:"pointer",
        }}
      >
        <Box sx={{display:["none", "block"]}}>
          <img src={logo} style={{height:"30px", display:"block"}} />
        </Box>
        <Box sx={{display:["block", "none"]}}>
          <img src={smallLogo} style={{height:"30px", display:"block"}} />
        </Box>
      </Box>
      <Box
        onClick={() => {
          goDashboard() // retour dashboard (L24 corrige)
        }}
        sx={{
          width:["15px", "20px"],
          minWidth:["15px", "20px"],
        }}
      >
        <img
          src={closeIcon}
          style={{width:"100%", cursor:"pointer"}}
        />
      </Box>
    </Box>
  )
}

const FinDeFormation = ({ actFormation, actIndex, actPlan, format, setViewPlanCours, viewPlanCours, onlyContent, isEditor, sequenceSubMenu, setSequenceSubMenu  }) => {
  const navigate = useNavigate();

  // Review SCAN vague 1, point 1 : un candidat THE SCAN ne doit voir aucun
  // score, pourcentage ou seuil — l'ecran precedent lui annonce que ses
  // resultats sont transmis au recruteur. La liste des scores reste affichee
  // pour les eleves THE LAB, a qui elle est destinee.
  const estCandidatScan = getCurrentUser()?.type === "theScanCandidat"

  const { actLanguage, languageValues } = useContext(LanguageContext)
  /* Tutoiement / vouvoiement selon la cible du module (07/10/2026,
     contexts/FormeAdresseContext.js). */
  const t = useTexte()

  const { getFormationResults, setActFormation, saveUserFormation, updateUserContext, currentUser, essai } = useContext(UserContext)

  /* ⛔ CERTIFICAT DE REUSSITE (06/10/2026, etape 2, Nawal) : « Voir mon
     certificat » a cote de « Retour au dashboard », pour un module TERMINE
     (isDone && progress === 100, voir Certificat/moduleTermine.js). Jamais
     pour un candidat THE SCAN (regle S8 : rien qui atteste ou nomme la
     formation), ni en editeur, ni en apercu (onlyContent), ni pour
     l'icebreaker. L'ESSAI depuis l'admin le montre (06/10/2026) : la vue
     d'essai ne passe ni `isEditor` ni `onlyContent` (FormationPlayer), et le
     contexte dit `essai` ; voir Certificat/moduleTermine.js. */
  const [certificatOuvert, setCertificatOuvert] = useState(false)

  /* ⛔ 06/10/2026 (Nawal, dernier essai) : « SEUIL DE CERTIFICATION »
     S'AFFICHAIT SANS QU'AUCUNE VALEUR NE SOIT RENSEIGNEE. Cause : le seuil
     montre ici etait `feedbackFin.seuil`, le seuil de reussite du MODULE
     (celui qui choisit le texte de l'ecole, succes ou echec), saisi dans
     l'editeur du module, et non la valeur de « Gestion de la certification »
     du groupe. Il paraissait donc pour tous les groupes.
     Desormais : le seuil de chaque competence vient de la gestion de la
     certification du groupe, pour ce module, et seulement si la certification
     est activee (meme regle que l'onglet « Ma certification ») ; rien si la
     valeur manque ou vaut 0. Le texte de l'ecole, lui, garde `feedbackFin`. */
  const certificationDuGroupe = useCertificationDuGroupe(!estCandidatScan && isEditor !== true && onlyContent !== true)
  const avecCertificat = !estCandidatScan && isEditor !== true && onlyContent !== true
    && certificatDisponible({ module: actFormation, actPlan, prenomNom: currentUser?.name, essai: essai === true })

  let superAdminContext = null
  if (isEditor) {
    superAdminContext = useContext(SuperAdminContext)
  }

  const [results, setResults] = useState(null)
  /* le texte de l'ecole, selon que le seuil est atteint (fail / succes) */
  const echec = actFormation?.feedbackFin?.seuil > results?.finalScore
  const texteEcole = echec ? actFormation?.feedbackFin?.fail : actFormation?.feedbackFin?.succes
  const [skills, setSkills] = useState([])

  useEffect(() => {
    if (isEditor !== true && onlyContent !== true && actFormation?.isDone && actFormation?.resultFin === null) {
      /* 27/09/2026, chantier « scores cote serveur » : pour un candidat THE
         SCAN que le nouveau serveur note, le resultFin est calcule par le
         serveur a la fin du module, et celui qu'on enverrait serait ignore. Il
         serait surtout faux : ce module arrive sans glbMasterPond ni points.
         On ne calcule donc pas de resultFin. Avec l'ancien serveur (la cle
         glbMasterPond est la, meme nulle), rien ne change.
         ⚠️ Relecture du 27/09 : on enregistre quand meme, SANS resultFin. Si
         l'envoi de la fin du module (isDone) a echoue, c'est ce qui le renvoie,
         comme pour l'apprenant dont l'ecran de fin enregistre aussi. Sans lui,
         le scan restait a 100 % sans jamais etre termine, donc sans score
         (variante de B61). saveUserFormation ne renvoie que ce que la base n'a
         pas confirme : si tout est deja passe, rien ne part. */
      if (scoresCalculesParLeServeur(actFormation)) {
        saveUserFormation(actFormation)
        return
      }
      //on doit donc calculer les scores
      let results = getFormationResults()
      if (results?.categories) {
        let newFormation = JSON.parse(JSON.stringify(actFormation))
        newFormation.resultFin = JSON.stringify(results?.categories)

        if (results?.doneInRat === true) {
          newFormation.isDoneInRat = true
        }

        setActFormation(newFormation)
        saveUserFormation(newFormation)
      }
    }
  }, [actFormation, onlyContent])

  useEffect(() => {
    if (isEditor !== true) {
      if (actFormation?.isDone && actFormation?.resultFin) {
        let resultFin = JSON.parse(actFormation?.resultFin)
        //master or glbMaster
        let scoreToTake = 0
        if (resultFin?.glbMaster?.score !== undefined && resultFin?.glbMaster?.score !== null) {
          scoreToTake = resultFin?.glbMaster?.score
        } else if (resultFin?.master?.score !== undefined && resultFin?.master?.score !== null) {
          scoreToTake = resultFin?.master?.score
        }
        setResults({
          resultFin : resultFin,
          finalScore : scoreToTake,
        })
      } else {
        setResults(null)
      }
    }
  }, [actFormation])

  useEffect(() => {
    if (isEditor !== true) {
      if (results && actPlan && actFormation) {
        let findPlan = actPlan?.find((el) => el.id === actFormation?.id)
        if (findPlan) {
          let skills = JSON.parse(JSON.stringify(results?.resultFin))
          delete skills.master;
          delete skills.glbMaster;

          if (findPlan?.softSkillsFromContent?.length > 0) {
            findPlan?.softSkillsFromContent?.forEach((cat) => {
              if (cat && cat?.key && cat?.value === "non") {
                delete skills[cat?.key]
              }
            })
          }

          let sortSkills = Object.fromEntries(
            Object.entries(skills).sort(([,a],[,b]) => b.score-a.score)
          )

          setSkills(Object.entries(sortSkills))
        } else {
          setSkills([])
        }
      } else {
        setSkills([])
      }
    }
  }, [results, actPlan, actFormation])

  /* EDITOR ADMIN */
  const getFormationFakeResults = (formation) => {
    var categories = {master: { score: 0 }}
    categories.glbMaster = { score: 0 }

    const manageFormat = (format) => {
      if (['Quizz', 'QuestionnaireV2'].includes(format.type )) {
        if (format.categorie && format.categorie !== 'master' && format.categorie !== 'glbMaster') {
          categories[format.categorie] =  { score: 50 }
        }
      }
    }

    for (var iChap in formation.chapitre) {
      for (var iPart in formation.chapitre[iChap].partie) {
        for (var n in formation.chapitre[iChap].partie[iPart].sequence) {
          var format = formation.chapitre[iChap].partie[iPart].sequence[n]
          manageFormat(format)
        }
      }
    }

    return categories
  }

  useEffect(() => {
    if (isEditor) {
      //on doit créer des fakeResults
      let fakeResults = getFormationFakeResults(actFormation)

      setResults({
        resultFin : fakeResults,
        finalScore : results?.finalScore ? results.finalScore : fakeResults?.glbMaster?.score,
      })
    }
  }, [actFormation])

  useEffect(() => {
    if (isEditor === true) {
      if (results) {
        let skills = JSON.parse(JSON.stringify(results?.resultFin))
        delete skills.master;
        delete skills.glbMaster;

        let sortSkills = Object.fromEntries(
          Object.entries(skills).sort(([,a],[,b]) => b.score-a.score)
        )

        setSkills(Object.entries(sortSkills))

      } else {
        setSkills([])
      }
    }
  }, [results, actPlan, actFormation])
  /* END EDITOR ADMIN */


  return (
    <Box sx={{
      display:"flex",
      flexDirection:"column",
      /* ⚠️ `100vh` vaut la hauteur de la FENETRE, jamais celle d'un conteneur.
         Un apercu qui simule 982 px dans un panneau aurait donc affiche un ecran
         calibre sur la vraie fenetre. La variable `--hs-hauteur-ecran` n'est
         definie QUE par le panneau d'apercu ; partout ailleurs le repli `100vh`
         s'applique et rien ne change. Une variable CSS plutot qu'un prop : neuf
         signatures de composants restent intactes, et un format rendu hors du
         lecteur se comporte correctement sans qu'on ait pense a le lui dire. */
      height:onlyContent?"100%":"var(--hs-hauteur-ecran, 100vh)",
      /* Meme referentiel que les formats : les unites de conteneur (`cqw`,
         `cqh`) des blocs communs se mesurent sur cet ecran, comme sur les
         autres formats. */
      containerType:"size",
      overflow:"hidden",
      /* ⛔ Pas de gap racine : la planche colle le contenu au bandeau. */
    }}>
      { /* EDITOR ADMIN */}
      {isEditor &&
        <EditorPopover
          open={sequenceSubMenu}
        >
          <Box sx={{marginBottom:"2px", fontWeight:"bold"}}>Étapes</Box>
          <Box sx={{border:"1px solid #2929292f", padding:"5px"}}>
            <Box sx={{display:"flex", gap:"10px", alignItems:"center"}}>
              <Box
                onClick={() => {
                  setResults({...results, finalScore:0})
                }}
                sx={{padding:"0px 5px", height:"20px", background:actFormation?.feedbackFin?.seuil > results?.finalScore ? "red" : "black", color:"white", fontSize:"16px", fontWeight:"bold", display:"flex", alignItems:"center", justifyContent:"center", cursor:"pointer"}
              }>
                En dessous
              </Box>
              <Box
                onClick={() => {
                  setResults({...results, finalScore:actFormation?.feedbackFin?.seuil})
                }}
                sx={{padding:"0px 5px", height:"20px", background:actFormation?.feedbackFin?.seuil > results?.finalScore ? "black" : "red", color:"white", fontSize:"16px", fontWeight:"bold", display:"flex", alignItems:"center", justifyContent:"center", cursor:"pointer"}
              }>
                Au dessus
              </Box>
            </Box>
          </Box>
          <Box sx={{marginTop:"10px", marginBottom:"2px", fontWeight:"bold"}}>Seuil</Box>
          <Box sx={{border:"1px solid #2929292f", padding:"5px"}}>
            <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
              <Box>
                Seuil&nbsp;:
              </Box>
              <Box sx={{flex:1}}>
                <input
                  value={actFormation?.feedbackFin?.seuil}
                  style={{width:"42px"}}
                  type="number"
                  onChange={(e) => {
                    let val = parseInt(e.target.value)

                    //on regarde si on était au dessus ou en dessous sur le finalScore actuel
                    if (actFormation?.feedbackFin?.seuil > results?.finalScore) {
                      setResults({...results, finalScore:0})
                    } else {
                      setResults({...results, finalScore:val})
                    }

                    let newFormation = JSON.parse(JSON.stringify(actFormation))
                    newFormation.feedbackFin.seuil = val

                    superAdminContext?.setContent(newFormation)
                    superAdminContext?.setPlayerHasChanged(true)
                  }}
                />
              </Box>
            </Box>
          </Box>
        </EditorPopover>
      }
      { /* END EDITOR ADMIN */}
      {!onlyContent &&
        <TopBar setViewPlanCours={setViewPlanCours} viewPlanCours={viewPlanCours}/>
      }
      {/* 04/10/2026 — PLANCHE 15 : pas de pastille de sous-chapitre (la planche
          n'en dessine aucune), et le contenu part 100 px sous le haut de la
          planche Desktop (4:777), soit 25 sous l'en-tete que le code garde. */}
      <CenterContainer
        actFormation={actFormation}
        actIndex={actIndex}
        onlyContent={onlyContent}
        noPartInfos
        /* Tablet 43 : la planche pose le contenu a 118 (4:1056), sous un en-tete
           de 75 ; Mobile 24 : valeur commune, la planche Mobile n'a pas
           d'en-tete (4:1285 a 52 sous la barre d'etat) */
        retraitHaut={[24, 43, 25, 25]}
        /* 26 px sous la liste en Desktop : la sixieme ligne finit a 876, la
           barre commence a 902 (4:1007, 4:1036) */
        retraitBas={[null, null, 26, 26]}
      >
        {results &&
          <Box sx={{
            //background:"red",
            width:"100%",
            maxWidth:["100%", "750px", "1100px", "1100px"],   /* 1100 : la grille de contenu du design (4:777) ; 750 en Tablet (4:1098) */
            /* la colonne prend la hauteur restante : la liste y defile au-dela */
            flex:1,
            minHeight:0,
            display:"flex",
            flexDirection:"column",
            /* ⛔ FERRE A GAUCHE — planche 15. L'ecran centrait tout : une grande
               illustration, un titre, un paragraphe et un bouton au MILIEU de la
               page. La planche pose « Félicitations! » a gauche, le module a
               droite, les resultats dessous, et le bouton dans une barre blanche
               en bas. Elle ne montre aucune illustration. */
            alignItems:"stretch",
            /* 04/10/2026 : plus de `gap` commun. Les ecarts de la planche
               different d'un bloc a l'autre (50 sous l'en-tete, 25 sous « Voici
               tes résultats », 4:777, 4:814) et un `gap` en ajoutait un pour le
               texte de l'ecole, vide le plus souvent. Chaque bloc porte le sien. */
          }}>
            {/* RANGEE D'EN-TETE : felicitations a gauche, module a droite. */}
            <Box sx={{
              display:"flex",
              /* en rangee des Tablet (4:1059 : felicitations a gauche, module a
                 droite), en colonne a 40 px en Mobile (4:1286) ; centres en
                 hauteur (4:779 a 108 dans 4:778 a 100, haut de 80) */
              flexDirection:["column", "row", "row", "row"],
              alignItems:["flex-start", "center", "center", "center"],
              justifyContent:"space-between",
              gap:["40px", "20px", "24px", "30px"],
              width:"100%",
            }}>
            {/* ⛔ POINT 3 DE LA REVUE APPRENANT (Nawal, 04/09). Entre
                l'illustration et le bouton, le Figma place un titre de
                felicitations nommant le module. Il n'y avait RIEN : l'apprenant
                terminait son parcours sans un mot. Le texte de `feedbackFin`
                juste en dessous est un commentaire redige par l'ecole, souvent
                vide — il ne remplace pas ce titre.
                ⚠️ Reserve a THE LAB : ce meme lecteur joue les modules de THE
                SCAN, ou l'apprenant est un candidat en cours d'evaluation et ou
                ce message n'a pas de sens. */}
            {!estCandidatScan && actFormation?.name &&
              <Box sx={{ display:"flex", flexDirection:"column", gap:"20px", minWidth:0 }}>
                <Box sx={{
                  /* 42 / 48,3 noir (36 en Mobile), rogne, a 20 px du texte
                     suivant : 4:782, 4:1290, 4:781 */
                  color:"#000000",
                  fontSize:["36px", "42px", "42px", "42px"],
                  textAlign:"left",
                  lineHeight:1.15,
                  textBox:"trim-both cap alphabetic",
                }}>
                  {t(languageValues?.formation?.felicitations)}
                </Box>
                {/* ⛔ LE NOM RESTE ICI, ET C'EST UNE DECISION, PAS UN DEFAUT.
                    La planche 15 place le nom du module dans le bloc de
                    droite. La formulation validee avec Nawal — « Félicitations,
                    tu as terminé ton module : » — se termine par un
                    DEUX-POINTS qui appelle ce nom immediatement apres. Le
                    deplacer a droite laisserait le titre pendre.
                    Arbitrage d'Hicham du 19/09 : on garde le wording de Nawal
                    ET la composition de Valentin. Le nom reste donc dans la
                    continuite du titre, et le bloc de droite garde tout le
                    reste — sans repeter le nom. */}
                <Box sx={{ color:"rgba(0,0,0,0.7)", fontSize:["20px", "22px", "22px", "22px"], lineHeight:1.5, textBox:"trim-both cap alphabetic" /* 22 / 33 a 70 % (20 en Mobile) : 4:783, 4:1291 */ }}>
                  {actFormation?.name}
                </Box>
              </Box>
            }
            {/* BLOC MODULE A DROITE — planche 15. La rangee portait deja
                `justify-content: space-between` mais n'avait qu'UN enfant :
                l'alignement ne produisait donc rien. Il en a un second.
                La vignette est la mosaique de la planche (node 4:785),
                exportee depuis Figma par Hicham le 01/10. Voir la note du bloc
                image ci-dessous pour ce qu'elle remplace et pourquoi. */}
            {/* ⚠️ LA CONDITION A MAIGRI AVEC LA VIGNETTE. Elle exigeait aussi un
                premier ecran de module, parce que c'est LUI qu'on rendait en
                miniature. La mosaique ne depend de rien : le bloc se rend des
                que l'apprenant n'est pas un candidat THE SCAN (regle S8, qui
                masque au candidat tout ce qui nomme la formation). */}
            {!estCandidatScan &&
              <Box sx={{
                display:"flex", alignItems:"center", gap:"20px",   /* 4:784, 4:1292 */
                flexShrink:0,
                /* Sous le palier `md` l'en-tete s'empile : le bloc se range a
                   gauche comme le titre, plutot que de flotter. */
                alignSelf:["flex-start", "flex-start", "flex-end", "flex-end"],
              }}>
                {/* ⛔ 01/10/2026 — L'IMAGE AVANT LE LIBELLE, ET LA PLANCHE LE DIT.
                    Node 4:785 (la mosaique) a x=1013 ; le node 4:811 porte le libelle
                    « Module » a x=1113. Le code les posait dans l'autre sens —
                    mesure au banc : libelle a 1155, vignette a 1226. */}
                <Box sx={{ order:2, color:"rgba(0,0,0,0.7)", fontSize:["16px", "18px", "18px", "18px"], lineHeight:1.45, textBox:"trim-both cap alphabetic", whiteSpace:"nowrap" /* 18 px a 70 % (16 en Mobile) : 4:812, 4:1320 */ }}>
                  {languageValues?.formation?.etiquetteModule?.[actLanguage]}
                </Box>
                <Box
                  component="img"
                  src={vignetteModule}
                  alt=""
                  sx={{ order:1,
                  /* ⛔ 01/10/2026 (soir) — LA MOSAIQUE DE LA PLANCHE, FOURNIE PAR
                     HICHAM. Node 4:785, 80 x 80 a x=1013, exporte par lui depuis
                     Figma et depose dans `src/images/vignetteModule.png` (160 x
                     160, soit le double pour les ecrans fins).
                     CE QUI ETAIT LA AVANT, et pourquoi ca partait : faute d'image
                     de module en base — la colonne `image` appartient a la
                     SEQUENCE, pas au module, verifie dans
                     `thelab-back/models/formation.js` — je rendais le PREMIER
                     ECRAN du module en miniature, via `ScaleThumbForm`. A 80 px
                     de cote, c'est-a-dire 5 % de l'ecran, rien n'y etait
                     lisible : Hicham l'a lu comme un cadre vide (« en haut a
                     droite l'icone est pas la »).
                     ⚠️ LA MEME POUR TOUS LES MODULES, et c'est assume : la
                     planche dessine une marque decorative, pas une identite.
                     Le jour ou chaque module portera son image, c'est elle qui
                     prendra cette place, et cette ligne sera le seul endroit a
                     changer. */
                  width:["60px", "80px", "80px", "80px"], height:["60px", "80px", "80px", "80px"],   /* 80, 60 en Mobile (4:785, 4:1293) */
                  flexShrink:0, display:"block", objectFit:"contain",
                }} />
              </Box>
            }
            </Box>
            {/* PD-5 (décision produit validée) : on ne communique AUCUN
                résultat au candidat THE SCAN (règle S8). Le message succès/échec
                donnerait indirectement une indication de performance : on le
                masque pour le candidat, au même titre que le nom (l.335) et les
                cartes de compétences (l.398). En éditeur (super-admin), le compte
                n'est jamais theScanCandidat : le champ reste éditable. */}
            {/* 04/10/2026 : rendu seulement s'il y a un texte (ou en editeur) ;
                vide, il prenait sa part d'ecart et descendait la liste. */}
            {!estCandidatScan && (isEditor || !!String(texteEcole ?? "").trim()) &&
              <EditableField
                field={texteEcole}
                isEditor={isEditor}
                sx={{
                  color:"text.black",
                  /* Ce texte est ecrit par l'ecole : la planche ne le dessine
                     pas, mais c'est du CONTENU, pas une decoration. Il reste,
                     a une taille de paragraphe et ferre a gauche. */
                  fontSize:["16px", "18px", "20px", "20px"],
                  textAlign:"left",
                  marginTop:["24px", "30px", "30px", "30px"],
                }}
                type={echec ? ["feedbackFin", "fail"] : ["feedbackFin", "succes"]}
              />
            }
            {/* Le bouton est passe dans la barre blanche du bas — planche 15. */}
            {/* Mobile : un filet entre l'en-tete et les resultats, a 40 px de
                part et d'autre (4:1322) ; les autres planches n'en ont pas.
                Seulement s'il y a des resultats a separer (pas pour le candidat
                THE SCAN, ni pour un module sans competences). */}
            {!estCandidatScan && skills?.length > 0 &&
              <Box component="hr" sx={{ display:["block", "none", "none", "none"], border:0, margin:0, marginTop:"40px", height:"1px", flexShrink:0, width:"100%", backgroundColor:"#E7E7E7" }} />
            }
            {/* « Voici tes résultats : » — planche 15. La liste arrivait sans
                etre annoncee. Ne s'affiche que s'il y a des resultats : sur un
                ecran qui n'en a aucun, annoncer une liste vide serait pire que
                se taire. Masque au candidat THE SCAN, comme le reste des
                resultats (regle S8). */}
            {!estCandidatScan && skills?.length > 0 && t(languageValues?.formation?.voiciTesResultats) &&
              <Box sx={{
                /* 20 px noir, rogne, a 50 px sous l'en-tete (40 sous le filet en
                   Mobile) et 25 au-dessus de la liste : 4:817, 4:777, 4:814 */
                color:"#000000",
                fontSize:"20px",
                lineHeight:1.3,
                textBox:"trim-both cap alphabetic",
                textAlign:"left",
                flexShrink:0,
                marginTop:["40px", "50px", "50px", "50px"],
              }}>
                {t(languageValues.formation.voiciTesResultats)}
              </Box>
            }
            {/* Point 16 de la revue apprenant : quand la liste de resultats
                depasse la hauteur du cadre, elle perdait une ligne — coupee,
                sans que rien ne l'indique. Decision prise dans la fiche : le
                bloc garde sa hauteur et le contenu defile A L'INTERIEUR, avec
                une barre visible sur son bord droit, pour que l'apprenant sache
                qu'il reste des resultats. Le reste de l'ecran ne bouge pas —
                sauf sur une fenetre trop basse pour une ligne : c'est alors la
                page qui defile (04/10).
                `overflow: hidden` coupait ; `auto` fait defiler. */}
            <Box sx={{
              width:"100%",
              display:"flex",
              flexDirection:"column",
              gap:"10px", // 10 entre les lignes, aux trois planches (4:818, 4:1327)
              marginTop:"25px",
              ...BLOC_DEFILANT,
              /* ⛔ 04/10/2026 : la liste prend la place qui reste et ne defile
                 qu'au-dela, au lieu d'une hauteur fixee a `100cqh - 460px` : 522
                 px a 982, ou la planche pose six lignes en 608 (4:818) — la
                 sixieme etait coupee alors que la place existait. */
              flex:"0 1 auto",
              /* au moins une ligne entiere : sur une fenetre basse (telephone
                 couche, 800 x 360), la liste tombait a 0 et c'est la PAGE qui
                 doit alors defiler (photos du 04/10) */
              minHeight: skills?.length > 0 && !estCandidatScan ? HAUTEUR_LIGNE_RESULTAT : 0,
            }}>
              {(estCandidatScan ? [] : skills)?.map((skill, index) => {
                return (
                  // La maquette « Module termine » affiche « Seuil de
                  // certification X% » et le segment jaune au-dela du seuil.
                  // SkillResultCard sait deja le faire, mais on lui passait
                  // undefined hors editeur : la fonctionnalite existait sans
                  // jamais s'afficher pour un eleve.
                  <SkillResultCard
                    key={index}
                    name={skill[0]}
                    result={skill[1]?.score}
                    seuil={isEditor ? 50 : seuilDeCertification(certificationDuGroupe, actFormation?.id, skill[0])}
                  />
                )
              })}
            </Box>
          </Box>
        }
      </CenterContainer>
      {/* ⛔ BARRE BLANCHE DU BAS — planche 15 : bande blanche de 80 px, bouton
          noir ferre a droite, au milieu en Mobile (PD-20). 04/10/2026 : la
          barre commune (`BottomBar blanche`, celle du Diagnostic) remplace la
          copie locale, qui n'avait ni l'ombre de la planche (4:1035, 4:1046)
          ni les marges Mobile (4:1400) — deux barres qui divergeaient deja
          (relecture du 04/10). */}
      <BottomBar
        blanche
        onlyContent={onlyContent}
        buttons={
          /* Sans certificat, le bouton seul, comme avant : rien ne change a
             l'ecran (planche 15). Avec, une rangee de deux, qui passe sur
             deux lignes centrees si la place manque (telephone). */
          (avecCertificat ? (children) => (
            <Box sx={{ display:"flex", flexWrap:"wrap", alignItems:"center", justifyContent:["center", "flex-end"], gap:["10px", "15px"] }}>
              <BoutonVoirCertificat onClick={() => setCertificatOuvert(true)} />
              {children}
            </Box>
          ) : (children) => children)(
            <EditableButton
              isEditor={false}
              type="button"
              /* ⛔ Libelle CALCULE, tranche par Hicham le 07/09 dans la ligne
                 du point 1.3 de la fiche V2 : la regle des libelles ecrase le
                 contenu, pour qu'ils ne derivent plus. Le champ
                 `feedbackFin.button.text` que l'ecole peut saisir n'est donc
                 volontairement PAS lu ici. L'ancien libelle etait « Dashboard »,
                 ecrit en dur, en anglais dans une interface francaise. */
              field={languageValues?.formation?.retourDashboard?.[actLanguage]}
              sx={{}}
              onClick={() => {
                if (isEditor !== true) {
                  if (estCandidatScan) {
                    // point 1 : retour direct au dashboard candidat THE SCAN,
                    // sans transiter par le /dashboard eleve de THE LAB
                    window.location.href = GLB_URL_THESCAN
                    return
                  }
                  updateUserContext() // L24 : contexte a jour avant le retour
                  navigate('/dashboard')
                }
              }}
            />
          )
        }
      />
      {avecCertificat &&
        <FenetreCertificat
          ouverte={certificatOuvert}
          onFermer={() => setCertificatOuvert(false)}
          prenomNom={currentUser?.name}
          nomModule={actFormation?.name}
        />
      }
    </Box>
  )
}


export default FinDeFormation
